import { TabView, TabPanel } from 'primereact/tabview';
import Header from '../../component/Header';
import './style.css';
import { useAuth } from '../../context/AuthContext';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/axios';
import utils from '../../utils/utils'

export default function CustomerDashboard() {
    const { authUser } = useAuth();
    const navigate = useNavigate()
    const [selectedDayIndex, setSelectedDayIndex] = useState(0);
    const [customerInfo, setCustomerInfo] = useState({});
    const [ticketInfo, setTicketInfo] = useState({});
    const { code } = useParams();
    const [latestTickets, setLatestTicket] = useState([]);
    const [days, setDayDate] = useState([]);
    const [callRecords, setcallRecords] = useState([]);
    const [escalatedTickets, setEscalatedTickets] = useState([]);
    const [todayTicket, setTodayTickets] = useState(0);

    const redirectToTicket = (url) => {
        navigate(`../view-ticket-history/${url}`);
    }

    useEffect(() => {
        CustomerDetails();
        TicketsList();
        getDayDate();
        getEscalatedTickets();
        getTodayTickets();
    }, [])

    const selectOption = (index, day) => {
        setSelectedDayIndex(index);
        dateWiseTickets(day);
    };

    const getEscalatedTickets = async () => {
        let response = await api.post(`/escalatedTickets`, { customerCode: code });
        console.log(response)
        setEscalatedTickets(response.data.tickets);
    }

    const getTodayTickets = async () => {
        let response = await api.post(`/dateWisetickets`, {
            "selectedDate": new Date().toISOString().split('T')[0],
            "customerCode": code
        });
        console.log(response)
        setTodayTickets(response.data?.length)
    }

    const dateWiseTickets = async (day) => {
        if (day?.createdDate) {
            let response = await api.post(`/dateWisetickets`, {
                "selectedDate": day?.createdDate,
                "customerCode": code
            });
            setcallRecords(response.data)
        }
    }
    const stripHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        // return 
        return div.textContent || div.innerText || "";
    }

    const getDayDate = async () => {
        let response = await api.post(`/datesForFilter`, { customerCode: code });
        setDayDate(response.data.data);
        if (response.data.data?.length) {
            dateWiseTickets(response.data.data[0]);
        }
    }

    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.trim().split(' ');
        const first = parts[0]?.[0] || '';
        const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
        return (first + last).toUpperCase();
    };

    const CustomerDetails = async () => {
        try {
            const res = await api.post(`/view_customer/${code}`);
            // const res = await api.post(`/view_customer/1053`);
            if (res.data.data) {
                setCustomerInfo(res.data.data);
            } else {
                console.warn("Unexpected data format:", res.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch agents:", error);
        }
    }

    const TicketsList = async () => {
        try {
            const res = await api.get(`/ticketListByCode/${code}`);
            if (res.data.data) {
                setTicketInfo(res.data.data);
                setLatestTicket(res.data.data['latestTickets'])
            }
            else {
                console.warn("Unexpected data format:", res.data);
            }
        }
        catch (error) {
            console.error("Failed to fetch agents:", error);
        }
    }
    return (
        <>
            <Header title subtitle="View Customer Details" searchbar backbtn="/customers-list"/>
            <div className='center-content'>
                <div className='customerDashboardInfo'>
                    <div className='flex-d-class'>
                        <h6>Welcome Back, {customerInfo.Customer_Name}.</h6>
                        <div className='avatar-img'>
                            <p>{getInitials(customerInfo?.Customer_Name)}</p>
                        </div>
                    </div>
                    <div className="address-details">
                        <div className="role">
                            <img src="../UserCircle.png" alt="User icon" />
                            <span>{customerInfo.Customer_Type}</span>
                        </div>
                        <div className="role">
                            <img src="../MapPin.png" alt="Location icon" />
                            <span>{customerInfo.State || ''}</span>
                        </div>
                        <div className="role">
                            <img style={{ width: 16, height: 16 }} src="../Phone.png" alt="Mobile icon" />
                            <span>{customerInfo.Contact_Mobile_No || ''}</span>
                        </div>
                        <div className="role email">
                            <img src="../EnvelopeSimple.png" alt="Email icon" />
                            <span>{customerInfo.Contact_Email_Id || ''}</span>
                        </div>
                    </div>

                    <div className='row top-marg'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12'>
                            <div className='row'>
                                <div className='col-xl-2 col-lg-3 col-md-6 info-col border-right align-left'>
                                    <div>
                                        <p className='h1heading'>Status</p>
                                        <p className='pill'><b>Active</b></p>
                                    </div>
                                </div>
                                <div className='col-xl-2 col-lg-3 col-md-6 info-col border-right align-center'>
                                    <div>
                                        <p className='h1heading'>Today's Tickets</p>
                                        <p className='customer-infop'><b>{todayTicket}</b></p>
                                    </div>
                                </div>
                                <div className='col-xl-2 col-lg-3 col-md-6 info-col border-right align-center'>
                                    <div>
                                        <p className='h1heading'>Total Tickets</p>
                                        <p className='customer-infop'><b>{ticketInfo.ticketCounts}</b></p>
                                    </div>
                                </div>
                                <div className='col-xl-2 col-lg-3 col-md-6 info-col border-right align-center'>
                                    <div>
                                        <p className='h1heading'>Pending Tickets</p>
                                        <p className='customer-infop'><b>{ticketInfo.pendingTicketCounts}</b></p>
                                    </div>
                                </div>
                                <div className='col-xl-2 col-lg-3 col-md-6 info-col border-right align-center'>
                                    <div>
                                        <p className='h1heading'>Resolved Tickets</p>
                                        <p className='customer-infop'><b>{ticketInfo.ticketCounts - ticketInfo.pendingTicketCounts}</b></p>
                                    </div>
                                </div>
                                <div className='col-xl-2 col-lg-3 col-md-6 info-col align-center'>
                                    <div>
                                        <p className='h1heading'>Escalated Tickets</p>
                                        <p className='customer-infop'><b>{escalatedTickets.length}</b></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='row'>
                    <div className='col-lg-6'>
                        <div className='totalCallList'>
                            <h6 className='call-h6'>Support Activity</h6>
                            <div >
                                <div className="weekdays-wrapper">
                                    {days?.map((day, index) => (
                                        <div
                                            key={index}
                                            className={`day-box ${selectedDayIndex === index ? 'selected' : ''}`}
                                            onClick={() => selectOption(index, day)}>
                                            <h6 className={`${selectedDayIndex === index ? 'day-box-selected' : 'weekday'}`}>{day.label}</h6>
                                            <h6 className="day-date">{day.date}</h6>
                                        </div>
                                    ))}
                                </div>
                                <div style={{
                                    ...(callRecords?.length > 0 && { marginInline: 10, marginBlock: 20 }),
                                    overflowY: 'auto',
                                    maxHeight: 313
                                }}>
                                    {callRecords?.length > 0 && callRecords.map((res, index) => (
                                        <div key={index} className='recordingDiv' style={{ cursor: 'pointer' }}>
                                            <div className='div-img'>
                                                <img src='../Ticket.png' />
                                            </div>
                                            <div className='div-content' onClick={e => redirectToTicket(res.Ticket_No)}>
                                                <h5><span style={{ fontWeight: 600 }}>{res.Ticket_No}</span> - {stripHtml(res.Issue_Details)}</h5>
                                                <p>{new Date(res.Create_Date_Time_Stamp).toISOString().split('T')[0]}</p>
                                            </div>
                                        </div>
                                    ))}
                                    {!callRecords.length && (
                                        <div style={{ textAlign: 'center', fontSize: 14, fontWeight: 500 }}>No Data Found</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='totalCallList'>
                            <h6 className='call-h6'>Latest Tickets</h6>
                            <div style={{ marginInline: 10, overflowY: 'auto', maxHeight: 404 }}>
                                {latestTickets?.map((res, index) => (
                                    <div className='mainTicketDiv' key={index}>
                                        <div className='recordingDiv latestTicket' style={{ cursor: 'pointer' }}>
                                            <div className='ticket-img'>
                                                <img src='../Ticket.png' />
                                            </div>
                                            <div className='ticketDiv' onClick={e => redirectToTicket(res.Ticket_No)}>
                                                <h5><span style={{ fontWeight: 600 }}>{res.Ticket_No}</span> - {stripHtml(res.Issue_Details)}</h5>
                                                <p>{new Date(res.Create_Date_Time_Stamp).toISOString().split('T')[0]}</p>
                                            </div>
                                        </div>
                                        <div className='status'>
                                            <span className={`status-pill ${res.Status}`}>{res.Status}</span>
                                        </div>
                                    </div>
                                ))}
                                {!latestTickets.length && (
                                    <div style={{ textAlign: 'center', fontSize: 14, fontWeight: 500 }}>No Data Found</div>
                                )}
                            </div>
                        </div>
                    </div>

                    {(
                        <div className='col-lg-12'>
                            <div className='totalCallList'>
                                <h6 className='call-h6'>Escalated Tickets</h6>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>S. No</th>
                                            <th>Ticket No</th>
                                            <th>Date</th>
                                            <th>Assigned To</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {escalatedTickets.length > 0 && escalatedTickets.map((res, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{res.Ticket_No}</td>
                                                <td>{new Date(res.Create_Date_Time_Stamp).toISOString().split('T')[0]}</td>
                                                <td>{res.escalatedTo || 'Level1'}</td>
                                            </tr>
                                        ))}
                                        {escalatedTickets.length == 0 && <tr><td></td><td></td><td><div style={{fontWeight : 500 , fontSize : 14}}>No Data Found</div></td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                </div>
            </div >
        </>
    )
}
